import React from "react";
import PropTypes from "prop-types";
import { Popover, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  infoPopover: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0px 5px 15px 0px rgba(0, 0, 0, 0.3)",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    maxWidth: 400,
    fontSize: "0.75rem",
  },
  infoContent: {
    "& h3": {
      fontWeight: "bold",
      fontSize: "0.875rem",
      marginBottom: theme.spacing(1),
      marginTop: 0,
      color: theme.palette.text.primary,
    },
    "& h4": {
      fontWeight: 600,
      fontSize: "0.8rem",
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(0.5),
      color: theme.palette.text.primary,
    },
    "& p": {
      fontSize: "0.75rem",
      lineHeight: 1.6,
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(0.5),
      marginTop: 0,
    },
    "& strong": {
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  },
}));

export default function PopoverInfoSection({
  open,
  anchorEl,
  onClose,
  htmlContent,
  anchorOrigin = { vertical: "bottom", horizontal: "right" },
  transformOrigin = { vertical: "top", horizontal: "right" },
}) {
  const classes = useStyles();

  if (!htmlContent) return null;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        className: classes.infoPopover,
      }}
      transitionDuration={300}
    >
      <Box
        className={classes.infoContent}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </Popover>
  );
}

PopoverInfoSection.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  htmlContent: PropTypes.string,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
  transformOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
};
